<script lang="ts">
	import { Toggle } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import { createEventDispatcher } from 'svelte';
	import { update } from 'src/stores/ui/edit_lists';

	const dispatch = createEventDispatcher();

	export let checked: boolean;
	export let roomConsumption: boolean;
	export let accountConsumption: boolean;

	let togglerText = $format('toggle_exclude_from_global_activity_log', {
		default: 'Disable event log reports for this device.',
	});

	switch ($update.type) {
		case 'measure_peak_power':
			togglerText = $format('label_measure_peak_power', {
				default: 'Use device to record peak consumption.',
			});
			break;
		case 'exclude_forgotten_lights':
			togglerText = $format('label_exclude_ai_forgotten', {
				default: 'Enable forgotten lights tracking.',
			});
			break;
		case 'ai_device_failure': // when conditions is $update.subType === 'manage_ai_notifications'
			togglerText = $format('label_exclude_ai_failure', {
				default: 'Enable "Failure detection" notifications and e-mails for this device.',
			});
			break;
		case 'pin_lock':
			togglerText = `${$format('enable', {
				default: 'Enable',
			})} ${$format('sub_settings_title_pin_lock', {
				default: 'pin lock',
			})}`;
			break;
	}
</script>

{#if $update.type === 'consumption_calculation'}
	<Toggle
		id="toggle-room-consumption"
		checked={roomConsumption}
		size="m"
		on:click={() => {
			roomConsumption = !roomConsumption;
			dispatch('toggler', { roomConsumption, accountConsumption });
		}}
	>
		{$format('exclude_from_total_room_energy', {
			default: 'Exclude from total room energy.',
		})}
	</Toggle>

	<Toggle
		id="toggle-account-consumption"
		checked={accountConsumption}
		size="m"
		on:click={() => {
			accountConsumption = !accountConsumption;
			dispatch('toggler', { roomConsumption, accountConsumption });
		}}
	>
		{$format('exclude_from_total_total_energy', {
			default: 'Exclude from total account energy.',
		})}
	</Toggle>
{:else}
	<Toggle
		id="toggle-consumption"
		{checked}
		size="m"
		on:click={() => {
			checked = !checked;
			dispatch('toggler', checked);
		}}
	>
		{togglerText}
	</Toggle>
{/if}
